import {Component, Module} from 'app/decorators';
import CompanyStore from 'app/stores/company';
import BasePicker from './base.picker';
import tpl from './company.picker.html';


//http://tools.medialab.sciences-po.fr/iwanthue/
let colors = [
    "#deb1e0",
    "#85e4d4",
    "#f1a7a2",
    "#5dcce3",
    "#d7c695",
    "#a4bfeb",
    "#d1ecba",
    "#e4b5ac",
    "#9ac899",
    "#9cd9d4",
];

@Module({
    name: "app.directives.company.picker",
    modules: [CompanyStore],
})
@Component({
    selector: 'blnd-company-picker',
    bindings: {
        ngModel: '=',
        ngDisabled: '=',
        ngChange: '&',
        mode: '@?',
        customer: '<?',
        allowEmpty: '<',
        testId: '@?',
    },
    template: tpl,
})
export default class C extends BasePicker {
    constructor ($scope, $element, $timeout, CompanyStore, UserService) {
        "ngInject";
        super($element);
        this.allowEmpty = _.isUndefined(this.allowEmpty) ? false : this.allowEmpty;
        this.$timeout = $timeout;
        this.mode = this.mode || 'view';
        this.$user = UserService.$user;

        this.ngModelId =  this.ngModel && this.ngModel.id;
        this.oldNgModel = this.ngModel;

        this.scope = $scope;
        this.colorStyle = {'background-color': '#999'};

        if (this.mode === 'edit') {
            this.store = CompanyStore;
            this.store.init();
            if (this.customer) {
                this.store.params.customers = this.customer.id; // Get customer companies
            }
            this.store.refresh();
        }
    }

    get list () {
        if (this.oldNgModel && !this.store.list.map(c => c.id).includes(this.oldNgModel.id)) {
            return [this.oldNgModel, ...this.store.list];
        } else {
            return this.store.list;
        }
    }

    _ngChange (newV, oldV) {
        this.ngModel = this.list.find(c => c.id === this.ngModelId);
        this.$timeout(() => {
            this.ngChange(newV, oldV)
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/directives/company.picker.js